import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { 
  faPencilAlt, 
  faCheck, 
  faTimes, 
  faTasks,
  faChevronRight,
  faChevronDown,
  faPlaneDeparture,
  faClock,
  faPlus,
  faMinus,
  faPaste,
} from '@fortawesome/free-solid-svg-icons'

import {
  faCalendarCheck, 
  faCalendarTimes,
  faUser,
  faTrashAlt,
  faComments
 } from '@fortawesome/free-regular-svg-icons'

library.add(
  faPencilAlt,
  faCheck,
  faTimes,
  faCalendarCheck,
  faCalendarTimes,
  faUser,
  faTasks,
  faChevronRight,
  faChevronDown,
  faPlaneDeparture,
  faClock,
  faPlus,
  faMinus,
  faTrashAlt,
  faComments,
  faPaste
);

Vue.component('font-awesome-icon', FontAwesomeIcon); // registered globally